import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../csr-web-api.service';

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './forgot-password-page.component.html'
})
export class ForgotPasswordPageComponent {
  private readonly fb = inject(FormBuilder);
  private readonly api = inject(CsrWebApiService);

  submitting = false;
  message = '';
  success = false;

  readonly form = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]]
  });

  async submit(): Promise<void> {
    if (this.form.invalid || this.submitting) {
      return;
    }

    this.submitting = true;
    this.message = '';
    try {
      await firstValueFrom(this.api.forgotPassword(this.form.controls.email.getRawValue()));
      this.success = true;
      this.message = 'Reset request sent successfully.';
    } catch {
      this.success = false;
      this.message = 'Could not send reset request.';
    } finally {
      this.submitting = false;
    }
  }
}
